import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LockerComponent } from './locker/locker.component';
import { ButtonModule, CheckboxModule } from '@shared';
import { SwitchModule } from '@shared/switch';
import { LockerBilletComponent } from './locker-billet/locker-billet.component';
import { LockerBlockComponent } from './locker-block/locker-block.component';
import { LockerCardComponent } from './locker-card/locker-card.component';

@NgModule({
  declarations: [LockerComponent, LockerBilletComponent, LockerBlockComponent, LockerCardComponent],
  imports: [CommonModule, ButtonModule, CheckboxModule, SwitchModule],
  exports: [LockerComponent, LockerBilletComponent, LockerBlockComponent, LockerCardComponent],
})
export class LockerModule {}
